export default "__VITE_ASSET__Bz1Kg8hb__"